import React, { useEffect, useState } from 'react'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Texto, NothingMessage } from '@gravitate-js/excalibrr'
import { Drawer, Skeleton } from 'antd'
import { panelModes } from '@components/_SiteWide/Navigation/ControlPanel/UserControlPanel'
import { BatchUpdate } from '@components/_SiteWide/AuditHistory/UpdateHistoryDrawer'
import { useOrders } from '@api/useOrders'

export const TrailerSwapSummary = ({ selectedAlert, setMode }) => {
  const [updateBatches, setUpdateBatches] = useState()
  const [loading, setLoading] = useState(false)
  const { trailerSwapMutation } = useOrders()
  const handleTrailerSwap = async () => {
    const data = await trailerSwapMutation.mutateAsync(selectedAlert.payload.orders.map((order) => order.audit_id))
    const reverse = data.reverse()
    setUpdateBatches(reverse)
    setLoading(false)
  }
  useEffect(() => {
    if (selectedAlert) {
      setLoading(true)
      handleTrailerSwap()
    }
  }, [selectedAlert])
  return (
    <>
      {selectedAlert && updateBatches && (
        <Drawer
          title='Trailer Swap Summary'
          placement='right'
          closable
          closeIcon={<ArrowLeftOutlined />}
          onClose={() => setMode(panelModes.DEFAULT)}
          open={!!selectedAlert}
          key='right'
          width='600'
          rootStyle={{
            height: '100%',
            overflowY: 'scroll',
          }}
        >
          <Texto className='p-3 mb-3' category='heading-small' appearance='medium'>
            AFFECTED ORDER(S)
          </Texto>
          <Content updateBatches={updateBatches} loading={loading} title={updateBatches[0].extra_data.number} />
        </Drawer>
      )}
    </>
  )
}

const Content = ({ updateBatches, loading }) => {
  let batch
  if (updateBatches && updateBatches.length === 1 && updateBatches[0].extra_data.actions) {
    batch = updateBatches[0].extra_data.actions
  }

  if (loading) {
    return <Skeleton active avatar paragraph={{ rows: 4 }} />
  } else
    return (
      <>
        {updateBatches.length === 1 &&
          batch.map((action, index) => {
            const title = `Order ${action.extra_data.number}`
            return <BatchUpdate key={index} batch={action} title={title} />
          })}
        {updateBatches.length > 1 &&
          updateBatches.map((batch) => {
            return batch.extra_data.actions.map((action, index) => {
              const title = `Order ${action.extra_data.number}`
              return <BatchUpdate key={index} batch={action} title={title} />
            })
          })}

        {!updateBatches.length && (
          <NothingMessage
            className='audit-no-data'
            title='No Audit History Exists'
            message='Future changes can be viewed here'
          />
        )}
      </>
    )
}
